<template>
  <ModalViewerButtonList :items="items" type="nav" theme="default" />
</template>
<script lang="ts" setup>
type ButtonType = {
  slug: string;
  title: string;
};

interface Props {
  contents: ContentModal[];
}

const props = defineProps({
  contents: null
});

const items = computed<ButtonType[]>(() => {
  return props.contents.map((content) => {
    if (content.post) {
      let title = content.post.title;
      switch (content.post.contentType) {
        case PostTypes.Subject:
          title = 'Sujet';
          break;
        case PostTypes.CorrectionPDF:
        case PostTypes.Correction:
          title = 'Corrigé';
          break;
      }
      return { slug: content.post.slug, title };
    }
    return { slug: content.category.slug, title: content.category.title };
  });
});
</script>
